import React, { useState } from "react";
import ToastMsg from "../../component/comman/ToastMsg";
import { useNavigate } from "react-router-dom";
import { changePassword } from "../../services/ApiServices";

const ChangePassword = () => {
  const navigate = useNavigate();
  const [old_password, setOldPassword] = useState("");
  const [new_password, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const handlePasswordUpdates = () => {
    if (new_password !== confirmPassword) {
      ToastMsg("New password and confirm password do not match", "error");
      return;
    }

    const passwordData = {
      old_password,
      new_password,
    };

    changePassword(passwordData)
      .then((res) => {
        if (res.status === 200) {
          ToastMsg("Password updated successfully!", "success");
        } else {
          console.error("Failed to update password:", res?.data);
          ToastMsg("Failed to update password", "error");
        }
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          navigate("/");
        }
        let error = err?.response?.data?.error || "something went wrong";
        ToastMsg(error, "error");
      });
  };

  return (
    <>
      <div className="profile-upper-wrapper">
        <div className="profile-picture">
          <p style={{fontSize:"25px"}}>
            {(localStorage.getItem("first_name") || "").charAt(0).toUpperCase()}
            {(localStorage.getItem("last_name") || "").charAt(0).toUpperCase()}
          </p>
        </div>
      </div>
      <div className="profile-lower-wrapper text-center w-100 w-lg-50">
        <div className="toggle-sc d-flex align-items-center justify-content-center">
        <h3 style={{ textTransform: "capitalize", marginTop:"-20px"}}>{localStorage.getItem("first_name") + " " + localStorage.getItem("last_name")}</h3>
        </div>
        <div className="card">
          <div className="card-body">
            <form>
              <div className="form-group">
                <label htmlFor="ols">Old Password</label>
                <input
                  type="text"
                  id="ols"
                  className="form-control"
                  value={old_password}
                  onChange={(e) => setOldPassword(e.target.value)}
                  autoComplete="off"
                />
              </div>
              <div className="form-group">
                <label htmlFor="new">New Password</label>
                <input
                  type="password"
                  id="new"
                  className="form-control"
                  value={new_password}
                  onChange={(e) => setNewPassword(e.target.value)}
                  autoComplete="new-password"
                />
              </div>
              <div className="form-group">
                <label htmlFor="confirm">Confirm Password</label>
                <input
                  type="password"
                  id="confirm"
                  className="form-control"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  autoComplete="new-password"
                />
              </div>
            </form>
          </div>
        </div>
        <div className="button-wrapper">
          <button className="btn">Cancel</button>
          <button className="btn" onClick={handlePasswordUpdates}>
            Change Password
          </button>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
